import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getLoveLanguage, UpdateLoveLanguage } from "../api/api";
import { useNavigate } from "react-router-dom";
import "../UpdateMatchPreferences/UpdateUploadMatchPreferences.css";

const fields = {
  preferred_love_receiving_method:
    "How do you prefer to receive love from your partner?",
  preferred_love_giving_method:
    "What is the most meaningful way for you to show love to someone?",
  importance_of_quality_time:
    "How important is quality time and undivided attention in your relationship?",
  words_vs_actions_affection:
    "How do you feel about expressing affection through words versus actions?",
  stress_support_preference:
    "What helps you feel most supported and cared for during stressful times?",
};

const validationSchema = Yup.object().shape(
  Object.fromEntries(
    Object.keys(fields).map((key) => [key, Yup.string().required("Required")])
  )
);

const UpdateUploadMatchPreferences = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(
    Object.fromEntries(Object.keys(fields).map((key) => [key, ""]))
  );

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = localStorage.getItem("currentUser");
        const parsed = JSON.parse(userData);
        const _id = parsed?.id || parsed?._id;
        if (_id) {
          const res = await getLoveLanguage({ user_id: _id });
          const data = res?.data || {};
          const formData = Object.fromEntries(
            Object.keys(fields).map((key) => [key, data[key] || ""])
          );
          setInitialValues(formData);
        }
      } catch (err) {
        console.error("Error fetching:", err);
        navigate("/LoginCreateAccounts");
      }
    };
    fetchUserData();
  }, []);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const userData = localStorage.getItem("currentUser");
        const parsed = JSON.parse(userData);
        const _id = parsed?.id || parsed?._id;

        const payload = {
          user_id: _id,
          profile_completion_status: "Tab",
          status: "0",
          ...Object.fromEntries(
            Object.entries(values).map(([key, val]) => [
              key,
              val.trim() || null,
            ])
          ),
        };

        const res = await UpdateLoveLanguage(payload);
        if (res?.success) {
          navigate("/Sidebar/EditProfile", { replace: true });
        }
      } catch (err) {
        console.error("Submit error:", err);
        alert("Something went wrong.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="love-language-wrapper">
      <div className="love-language-form">
        <h2 className="form-title">Update Love Language Preferences</h2>
        <form onSubmit={formik.handleSubmit}>
          {Object.entries(fields).map(([key, label]) => (
            <div className="form-field" key={key}>
              <label htmlFor={key} className="form-label">
                {label}
              </label>
              <textarea
                id={key}
                name={key}
                className="form-textarea"
                value={formik.values[key]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Type your answer (Optional)"
                rows={4}
              />
              {formik.touched[key] && formik.errors[key] && (
                <div className="form-error">{formik.errors[key]}</div>
              )}
            </div>
          ))}

          <div className="form-actions">
            <button
              type="button"
              className="form-button secondary"
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              Back
            </button>
            <button
              type="submit"
              className="form-button primary"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateUploadMatchPreferences;
